import { Component, Input, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import { AppAuthService } from 'app/shared/services/app-auth.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { Filter } from 'app/shared/components/table/filter';
import { CommonService } from 'app/shared/services/common.service';
import { CouponService } from 'app/core/services/coupon.service';
import { BusinessManagmentService } from 'app/core/services/business-managment.service';

@Component({
  selector: 'app-atn-export-excel',
  templateUrl: './atn-export-excel.component.html',
  styleUrls: ['./atn-export-excel.component.css']
})
export class AtnExportExcelComponent implements OnInit {
  [x: string]: any;
  @Input() request: any;
  @Input() table: any;
  @Input() fileName = 'data';
  newTable: [{}] = [{}]
  constructor(private localizationService: LocalizationService, private appAuthService: AppAuthService,
    private commonService: CommonService, private couponService: CouponService, private managerService: BusinessManagmentService) {
  }

  ngOnInit(): void {
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }
  onExport() {
    if (this.fileName === 'customers') {
      this.exportCustomersToExcel();
    } else if (this.fileName === 'BusinessCoupon') {
      this.exportBusinessCouponToExcel();
    }
    else if (this.fileName === 'leadsForManager') {
      this.exportLeadsForManager()
    }
    else if (this.fileName === 'businesses') {
      this.exportBusinesses()
    }
  }
  get exportTooltip(): string {
  switch (this.fileName) {
    case 'customers':
      return this.localizationService.Translate('LIDS.EXPORT_TO_ALL_LIDS');
    case 'BusinessCoupon':
      return this.localizationService.Translate('BUSINESS_COUPON.EXPORT');
    case 'leadsForManager':
      return this.localizationService.Translate('LEADS_MANAGMENT.EXPORT_TO_EXCEL');
    case 'businesses':
      return this.localizationService.Translate('BUSINESS_MANAGEMENT.EXPORT_TO_EXCEL');
    default:
      return '';
  }
}
  exportCustomersToExcel() {
    this.commonService.exportCustomersToExcel(this.request.BussinessId,
      this.request.Filter,
      this.request.Filter.Paging,
    )
      .subscribe(blob => {
        this.saveAsExcelFile(blob, 'lids');
      }, (err) => {
        console.log(err);
      })
  }
  exportBusinessCouponToExcel() {
    this.couponService.exportBusinessCouponToExcel(this.businessId, this.request.Filter,
      this.request.Filter.Paging,)
      .subscribe(blob => {
        this.saveAsExcelFile(blob, 'BusinessCoupons');
      }, (err) => {
        console.log(err);
      })
  }
  exportLeadsForManager() {    
        this.request.Filter.BusinessId=null;
        this.request.Filter.CategoryId=null;
        this.request.Filter.CreatedAt=null;
        this.request.SortField=null;
        this.request.SortOrder=null;
        this.request.Paging=null;
    this.managerService.exportLeadsForManager(this.request).subscribe(blob => {
      this.saveAsExcelFile(blob, 'AllLeads');
    }, (err) => {
      console.log(err);
    })
  }
  exportBusinesses() {
    this.managerService.exportBusinesses(this.request).subscribe(blob => {
      this.saveAsExcelFile(blob, 'Businesses');
    }, (err) => {
      console.log(err);
    })
  }
}


